import { useCallback } from "react";

import {
  assignAlertedProductsManagementType,
  createAlertedProductsRequest,
  gestionarHomologacionProductos,
} from "../../../entities/alerted-product";
import {
  HOMOLOGACION_ERROR_MESSAGES,
  MANAGEMENT_ERROR_MESSAGES,
  REQUEST_ERROR_MESSAGES,
  buildServiceResult,
} from "../lib/serviceResult";

// Orquesta los dos recursos del envío: actualizar la gestión y, solo si esa
// respondió OK, crear la solicitud documental.
export const useManagementRequestSubmit = ({ appliedFilters, onManagementSuccess }) =>
  useCallback(
    async ({ managementTypeId, observation, pdf, selectedRows, isHomologation }) => {
      if (!appliedFilters) return undefined;

      const result = { management: null, request: null, success: false };
      let encabezadoId = null;

      try {
        const managementResponse = await assignAlertedProductsManagementType({
          managementTypeId,
          selectedRows,
        });
        onManagementSuccess?.();
        encabezadoId = managementResponse?.id_encabezado ?? null;
        result.management = {
          label: "Gestión de alertas",
          ok: true,
          status: 200,
          code: null,
          message:
            managementResponse?.mensaje || "Tipo de gestión actualizado correctamente.",
        };
      } catch (error) {
        result.management = buildServiceResult(
          "Gestión de alertas",
          error,
          MANAGEMENT_ERROR_MESSAGES
        );
      }

      if (result.management?.ok && isHomologation) {
        // HOMOLOGACIÓN: el segundo recurso es el endpoint de homologación, que
        // necesita el id_encabezado devuelto por la gestión.
        if (encabezadoId == null) {
          result.request = {
            label: "Homologación",
            ok: false,
            status: null,
            code: "ENCABEZADO_NO_DISPONIBLE",
            message:
              "No se recibió el identificador del encabezado (id_encabezado) desde la gestión de alertas. No es posible continuar con la homologación.",
          };
        } else {
          try {
            const homologacionResponse = await gestionarHomologacionProductos({
              idEncabezado: encabezadoId,
              observation,
              pdf,
              selectedRows,
            });
            result.request = {
              label: "Homologación",
              ok: true,
              status: 200,
              code: null,
              message:
                homologacionResponse?.mensaje ||
                "Homologación gestionada correctamente.",
            };
          } catch (error) {
            result.request = buildServiceResult(
              "Homologación",
              error,
              HOMOLOGACION_ERROR_MESSAGES
            );
          }
        }
      } else if (result.management?.ok) {
        try {
          const requestResponse = await createAlertedProductsRequest({
            observation,
            pdf,
            selectedRows,
          });
          result.request = {
            label: "Solicitud documental",
            ok: true,
            status: 201,
            code: null,
            message: requestResponse?.mensaje || "Solicitud creada correctamente.",
          };
        } catch (error) {
          result.request = buildServiceResult(
            "Solicitud documental",
            error,
            REQUEST_ERROR_MESSAGES
          );
        }
      }

      // id_encabezado del primer servicio (gestión): se usa para armar el
      // mensaje de éxito ("... El id de la solicitud es: {id_encabezado}").
      result.encabezadoId = encabezadoId;
      result.success = Boolean(result.management?.ok && result.request?.ok);
      return result;
    },
    [appliedFilters, onManagementSuccess]
  );